if (import.meta.hot) {
  import.meta.hot.accept();
}

import '@assets/Scss/global.scss';
import '@assets/Scss/component/nav.scss';
import '@assets/Scss/component/transitions.scss';
import '@assets/Scss/component/close.scss';
import '@assets/Scss/component/offcanvas.scss';
import '@assets/Scss/component/dropdown.scss';
import '@assets/Scss/header.scss';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/dropdown';


// Auto-Hide Header beim Scrollen
(() => {
  const header = document.querySelector('header');

  if (!header) return;

  let lastScroll = 0;
  let ticking = false;

  // Header-Höhe als CSS-Variable setzen
  const updateHeaderHeight = () => {
    const height = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  };

  // Initial und bei Resize
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);

  // Bootstrap Dropdowns im Header schließen
  const closeHeaderDropdowns = () => {
    // Alle geöffneten Dropdowns im Header finden
    const openDropdowns = header.querySelectorAll('.dropdown.show, .dropdown-menu.show');

    openDropdowns.forEach(dropdown => {
      // Bootstrap 5 API verwenden, falls verfügbar
      if (typeof window.bootstrap !== 'undefined' && window.bootstrap.Dropdown) {
        const dropdownToggle = dropdown.querySelector('[data-bs-toggle="dropdown"]');
        if (dropdownToggle) {
          const bsDropdown = window.bootstrap.Dropdown.getInstance(dropdownToggle);
          if (bsDropdown) {
            bsDropdown.hide();
          }
        }
      }
      // Fallback: Klassen manuell entfernen (Bootstrap 4 & 5 kompatibel)
      dropdown.classList.remove('show');
      const menu = dropdown.querySelector('.dropdown-menu');
      if (menu) {
        menu.classList.remove('show');
      }
    });
  };

  // Scroll-Handler
  const handleScroll = () => {
    const currentScroll = window.pageYOffset;

    // Ignoriere kleine Scroll-Bewegungen
    if (Math.abs(currentScroll - lastScroll) < 5) return;

    // Nach unten scrollen (Header ausblenden)
    if (currentScroll > lastScroll && currentScroll > header.offsetHeight) {
      // Alle geöffneten Bootstrap Dropdowns im Header schließen
      closeHeaderDropdowns();
      header.classList.add('header--hidden');
    }
    // Nach oben scrollen (Header einblenden)
    else if (currentScroll < lastScroll) {
      header.classList.remove('header--hidden');
    }

    lastScroll = currentScroll;
  };

  // Throttle mit requestAnimationFrame
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

